import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {map, Observable} from "rxjs";
import {ActionResult, ActionResultList, RaceSettings} from "@model";
import {EnvironmentService} from "./environment.service";

@Injectable({providedIn: 'root'})
export class RaceSettingsService {
  public static readonly BLOCK_RACE_EDIT_NOT_ALLOWED: number = 10;
  public static readonly START_BY_TYPE_EDIT_NOT_ALLOWED: number = 11;

  constructor(private http: HttpClient, private environmentService: EnvironmentService) {
  }

  fetchRaceSettings = (raceId?: number): Observable<RaceSettings | null> =>
    this.http.post<ActionResult<RaceSettings>>(this.environmentService.getApiUrl() + "/api/public/racesettings/getbyraceid", raceId)
      .pipe(map(value => value?.result ?? null));

  fetchRaceSettingsByEventId = (eventId?: number): Observable<RaceSettings[]> =>
    this.http.get<ActionResultList<RaceSettings[], number>>(this.environmentService.getApiUrl() + `/api/public/racesettings/getbyeventid?eventId=${eventId}`)
      .pipe(map(value => value?.result ?? []));

  updateRaceSettings = (settings: RaceSettings, onSuccess: () => void, onError: (resultCode: number | undefined) => void): void => {
    this.http.post<ActionResult<boolean>>(this.environmentService.getApiUrl() + "/api/racesettings/update", settings)
      .subscribe(actionResult => {
        const code = actionResult.resultCode;
        if (code === -1 || code === RaceSettingsService.BLOCK_RACE_EDIT_NOT_ALLOWED ||
            code === RaceSettingsService.START_BY_TYPE_EDIT_NOT_ALLOWED) {
          onError(code);
        } else {
          onSuccess();
        }
      });
  }
}
